export default {
    resetPin: 'Reset PIN',
    pin: 'PIN',
    confirmPin: 'Confirm PIN',
    save: 'Save',
    incorrectPin: 'Incorrect PIN',
    msgPinDontmatch: 'PIN and confirm do not match',
    congratulation: 'Congratulation',
    msgSaveSuccess: 'PIN is updated.'
}
